const TspData = ({ data }) => {
    return (
        <>
            {
                data.map((curData => {
                    const { id, name, scope, year, supplier, category, source, discription, groundwater, surface_water, sea_water, third_party, produced, nox, sox, pm, pb, hg, total } = curData;

                    return (
                        <tr key={id}>
                            <th >{name}</th>
                            <td >{scope}</td>
                            <td >{year}</td>
                            <td >{supplier}</td>
                            <td >{category}</td>
                            <td >{source}</td>
                            <td >{discription}</td>
                            <td >{groundwater}</td>
                            <td >{surface_water}</td>
                            <td >{sea_water}</td>
                            <td >{third_party}</td>
                            <td >{produced}</td>
                            <td >{nox}</td>
                            <td >{sox}</td>
                            <td >{pm}</td>
                            <td >{pb}</td>
                            <td >{hg}</td>
                            <td >{total}</td>
                        </tr>
                    )
                }))
            }
        </>
    )
}

export default TspData;